// src/ui/ThemeManager.js
export class ThemeManager {
  constructor() {
    this._theme = 'light';
  }

  init() {
    const saved = localStorage.getItem('theme');
    if (saved === 'dark' || saved === 'light') {
      this._theme = saved;
    } else {
      this._theme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }
    this._apply();
  }

  toggle() {
    this._theme = this._theme === 'dark' ? 'light' : 'dark';
    localStorage.setItem('theme', this._theme);
    this._apply();
  }

  get isDark() {
    return this._theme === 'dark';
  }

  _apply() {
    document.documentElement.setAttribute('data-theme', this._theme);
  }
}
